import { Directive, inject, input, InputSignal } from '@angular/core';
import { HighlightChannel } from '../service/highlight.channels';
import { HighlightService } from '../service/highlight.service';
import { AbstractSearchDirective } from './abstract-search.directive';

@Directive({
  selector: '[ngModel][appHighlight]',
  exportAs: 'appHighlight',
})
export class AppHighlightDirective extends AbstractSearchDirective<HighlightChannel> {
  #highlightService = inject(HighlightService);

  readonly appHighlight = input<HighlightChannel>();

  readonly channelInput: InputSignal<HighlightChannel> = this
    .appHighlight as InputSignal<HighlightChannel>;

  protected setSearch(channel: HighlightChannel, value: string) {
    this.#highlightService.setSearch(channel, value);
  }
}
